export default __webpack_public_path__ + "static/breadcrumbs-size-dont-dark-404b6833b2e138311d15640f6bb1f8a8bb9ccc666a936d118ec2629d0029a268.png";